import { useAuth } from "../context/AuthProvider";

export const NEW_URL = "https://labs.cynetcorp.com";
export const EXPIRES_ON = "09/22/2026";
const OLD_HOSTS = ["cynetlabs.web.app", "cynetlabs.firebaseapp.com"];
// End of 22 Sep 2026 IST (Asia/Kolkata). From 23 Sep 00:00 IST the old URL is off.
const EXPIRES_AT_MS = Date.parse("2026-09-22T18:30:00.000Z");

export function isLegacyHost() {
  if (typeof window === "undefined") return false;
  return OLD_HOSTS.includes(window.location.hostname);
}

export function isLegacyUrlExpired() {
  return Date.now() >= EXPIRES_AT_MS;
}

export default function UrlSunsetWarning() {
  const { loading } = useAuth();

  if (!isLegacyHost() || !isLegacyUrlExpired() || loading) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="url-warning-title"
    >
      <div className="w-full max-w-md rounded-2xl border border-amber-400/40 bg-[#12141c] p-6 text-center shadow-2xl">
        <p className="mb-2 text-xs font-bold tracking-widest text-amber-400">
          WARNING
        </p>
        <h2
          id="url-warning-title"
          className="mb-3 text-xl font-semibold text-white"
        >
          This link is no longer available
        </h2>
        <p className="mb-4 text-sm leading-relaxed text-slate-300">
          The previous Cynet Labs URL has been turned off. Please use the
          updated URL below.
        </p>
        <a
          href={NEW_URL}
          className="mb-5 block rounded-lg border border-slate-600 bg-black/40 px-3 py-2 text-sm font-semibold text-white hover:border-amber-400"
        >
          {NEW_URL}
        </a>
        <a
          href={NEW_URL}
          className="inline-flex w-full items-center justify-center rounded-lg bg-amber-400 px-4 py-2.5 text-sm font-bold text-black hover:bg-amber-300"
        >
          Open new URL
        </a>
      </div>
    </div>
  );
}
